<footer class=" background-img ">
    <div class="background-overlay ">
        <div class="container">
            <div class="row justify-content-center">
                <!-- Footer Logo and About Section -->
                <div class="col-md-3 col-sm-12 mb-2-5 mb-lg-0">
                    <a href="#" class="footer-logo bg-white mb-3">
                        <img src="assets/img/logos/logo_footer.png" alt="Footer Logo">
                    </a>
                    <p class="mb-1-6 text-white blur-background">
                        Learning gives creativity, creativity leads to thinking, thinking provides knowledge, and
                        knowledge
                        makes you great.
                    </p>
                    <!-- Social Icons Section -->
                    <div class="social-icons d-flex gap-3 mt-3">
                        <a href="https://www.facebook.com/ARNI.Education/" target="_blank" class="text-white "
                           title="Facebook">
                            <i class="fa-brands fa-facebook-f fb-icon"></i>
                        </a>
                        <a href="https://twitter.com/ArniUniversity1?s=08" target="_blank" class="text-white "
                           title="Twitter">
                            <i class="fa-brands fa-twitter twitter-icon"></i>
                        </a>
                        <a href="https://www.youtube.com/watch?v=RSa3v7KV2h4" target="_blank" class="text-white "
                           title="YouTube">
                            <i class="fa-brands fa-youtube youtube-icon"></i>
                        </a>
                        <a href="https://api.whatsapp.com/send?phone=917876500601&amp;lang=en" target="_blank"
                           class="text-white " title="WhatsApp">
                            <i class="fa-brands fa-whatsapp whatsapp-icon"></i>
                        </a>
                        <a href="https://instagram.com/arni.university?utm_medium=copy_link" target="_blank"
                           class="text-white " title="Instagram">
                            <i class="fa-brands fa-instagram instagram-icon"></i>
                        </a>
                    </div>

                </div>

                <!-- Get in Touch Section -->
                <div class="col-md-3 mb-2-5 mb-lg-0 text-white ">
                    <div class="ps-md-1-6 ps-lg-1-9 blur-background" style="word-break: break-word;">
                        <h3 class="text-secondary h5 mb-3">Get in Touch</h3>
                        <ul class="footer-list list-unstyled">
                            <li class="mb-2">
                                <i class="fa fa-phone me-2 text-secondary"></i>
                                <strong>Phone:</strong> <a href="tel:18008918962">18008918962</a>, <a
                                href="tel:7876848080">78-7684-8080</a>, <br>International: <a href="tel:+2349030848195">+2349030848195</a>
                            </li>
                            <li class="mb-2">
                                <i class="fa fa-envelope me-2 text-secondary"></i>
                                <strong>Email:</strong> <a href="mailto:info@arniuniversity.edu.in" class="text-white">info@arniuniversity.edu.in</a>
                            </li>
                            <li class="mb-2">
                                <i class="fa fa-globe me-2 text-secondary"></i>
                                <strong>Website:</strong> <a href="https://www.arniuniversity.edu.in"
                                                             class="text-white">www.arniuniversity.edu.in</a>
                            </li>
                            <li class="mb-2">
                                <i class="fa fa-map-marker-alt me-2 text-secondary"></i>
                                <strong>Address:</strong> Arni University, Kathgarh, HP, India
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Useful Links Section -->
                <div class="col-md-3 mb-2-5 mb-md-0 text-white ">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <div class="ps-lg-1-9 ps-xl-2-5 blur-background">
                                <h3 class="text-secondary h5 mb-3">Useful Links</h3>
                                <ul class="footer-list list-unstyled">
                                    <li class="mb-2">
                                        <a href="https://www.ugc.gov.in/" class="text-white" target="_blank"
                                           rel="noopener noreferrer">
                                            <i class="fa fa-link me-2 text-secondary"></i>UGC
                                        </a>
                                    </li>
                                    <li class="mb-2">
                                        <a href="https://www.aicte-india.org/" class="text-white" target="_blank"
                                           rel="noopener noreferrer">
                                            <i class="fa fa-link me-2 text-secondary"></i>AICTE
                                        </a>
                                    </li>
                                    <li class="mb-2">
                                        <a href="https://www.pci.nic.in/" class="text-white" target="_blank"
                                           rel="noopener noreferrer">
                                            <i class="fa fa-link me-2 text-secondary"></i>PCI
                                        </a>
                                    </li>
                                    <li class="mb-2">
                                        <a href="https://hp.gov.in/hpperc/" class="text-white" target="_blank"
                                           rel="noopener noreferrer">
                                            <i class="fa fa-link me-2 text-secondary"></i>HP-PERC
                                        </a>
                                    </li>
                                    <li class="mb-2">
                                        <a href="http://www.education.hp.gov.in/" class="text-white" target="_blank"
                                           rel="noopener noreferrer">
                                            <i class="fa fa-link me-2 text-secondary"></i>Directorate of Higher
                                            Education
                                        </a>
                                    </li>
                                </ul>

                            </div>
                        </div>
                        <div class="col-12">
                            <div class="ps-lg-1-9 ps-xl-2-5 blur-background">
                                <h3 class="text-secondary h5 mb-3">Quick links</h3>
                                <ul class="footer-list list-unstyled">
                                    <li class="mb-2">
                                        <a class="text-white"
                                           rel="noopener noreferrer" routerLink="/conference">
                                            <i class="fa fa-link me-2 text-secondary"></i>CONFERENCE
                                        </a>
                                    </li>
                                    <li class="mb-2">
                                        <a class="text-white"
                                           rel="noopener noreferrer" routerLink="/library">
                                            <i class="fa fa-link me-2 text-secondary"></i>LIBRARY
                                        </a>
                                    </li>
                                    <li class="mb-2">
                                        <a routerLink="/contact" class="text-white"
                                           rel="noopener noreferrer">
                                            <i class="fa fa-link me-2 text-secondary"></i>CONTACT
                                        </a>
                                    </li>
                                    <li class="mb-2">
                                        <a class="text-white"
                                           rel="noopener noreferrer" routerLink="/photo-gallery">
                                            <i class="fa fa-link me-2 text-secondary"></i>GALLERY
                                        </a>
                                    </li>
                                    <li class="mb-2">
                                        <a class="text-white"
                                           rel="noopener noreferrer" routerLink="/career">
                                            <i class="fa fa-link me-2 text-secondary"></i>CAREER
                                        </a>
                                    </li>

                                    <li class="mb-2">
                                        <a class="text-white"
                                           rel="noopener noreferrer" routerLink="/news">
                                            <i class="fa fa-link me-2 text-secondary"></i>NEWS
                                        </a>
                                    </li>

                                    <li class="mb-2">
                                        <a class="text-white"
                                           rel="noopener noreferrer" routerLink="/enquiry">
                                            <i class="fa fa-link me-2 text-secondary"></i>ENQUIRY
                                        </a>
                                    </li>

                                    <li class="mb-2">
                                        <a class="text-white" target="_blank"
                                           rel="noopener noreferrer" href="https://arni.in/2024/24Entranceex.aspx">
                                            <i class="fa fa-link me-2 text-secondary"></i>PHD ENTRANCE EXAM
                                        </a>
                                    </li>

                                    <li class="mb-2">
                                        <a href="https://admin.arni.in/" class="text-white" target="_blank"
                                           rel="noopener noreferrer">
                                            <i class="fa fa-link me-2 text-secondary"></i>ADMIN PANEL
                                        </a>
                                    </li>

                                    <li class="mb-2">
                                        <a class="text-white" target="_blank"
                                           rel="noopener noreferrer" href="https://student.arni.in/">
                                            <i class="fa fa-link me-2 text-secondary"></i>STUDENT PANEL
                                        </a>
                                    </li>

                                    <li class="mb-2">
                                        <a class="text-white"
                                           rel="noopener noreferrer" routerLink="/enquiry">
                                            <i class="fa fa-link me-2 text-secondary"></i>APPLY NOW
                                        </a>
                                    </li>
                                </ul>

                            </div>
                        </div>
                    </div>

                </div>

                <!-- academic Links Section -->
                <div class="col-md-3 mb-2-5 mb-md-0 text-white ">
                    <div class="ps-lg-1-9 ps-xl-2-5 blur-background">
                        <h3 class="text-secondary h5 mb-3">Academic Links</h3>
                        <ul class="footer-list list-unstyled">
                            <li class="mb-2">
                                <a class="text-white cursor-pointer" target="_blank"
                                   rel="noopener noreferrer" (click)="goTo('ast')">
                                    <i class="fa fa-link me-2 text-secondary"></i>Arni School of
                                    Technology
                                </a>
                            </li>
                            <li class="mb-2">
                                <a class="text-white cursor-pointer" target="_blank"
                                   rel="noopener noreferrer" (click)="goTo('asbmc')">
                                    <i class="fa fa-link me-2 text-secondary"></i>Arni School of
                                    Business Management &
                                    Commerce
                                </a>
                            </li>
                            <li class="mb-2">
                                <a class="text-white cursor-pointer" target="_blank"
                                   rel="noopener noreferrer" (click)="goTo('asah')">
                                    <i class="fa fa-link me-2 text-secondary"></i>Arni School of Arts &
                                    Humanities
                                </a>
                            </li>
                            <li class="mb-2">
                                <a class="text-white cursor-pointer" target="_blank"
                                   rel="noopener noreferrer" (click)="goTo('asbsbt')">
                                    <i class="fa fa-link me-2 text-secondary"></i>Arni School of Basic
                                    Sciences &
                                    Bio-Technology
                                </a>
                            </li>
                            <li class="mb-2">
                                <a class="text-white cursor-pointer" target="_blank"
                                   rel="noopener noreferrer" (click)="goTo('asahs')">
                                    <i class="fa fa-link me-2 text-secondary"></i>Arni School of Allied
                                    Health
                                    Sciences
                                </a>
                            </li>

                            <li class="mb-2">
                                <a class="text-white cursor-pointer" target="_blank"
                                   rel="noopener noreferrer" (click)="goTo('asp')">
                                    <i class="fa fa-link me-2 text-secondary"></i>Arni School of Pharmacy
                                </a>
                            </li>

                            <li class="mb-2">
                                <a class="text-white cursor-pointer" target="_blank"
                                   rel="noopener noreferrer" (click)="goTo('asa')">
                                    <i class="fa fa-link me-2 text-secondary"></i>Arni School of Agriculture
                                </a>
                            </li>

                            <li class="mb-2">
                                <a class="text-white cursor-pointer" target="_blank"
                                   rel="noopener noreferrer" (click)="goTo('ashmt')">
                                    <i class="fa fa-link me-2 text-secondary"></i>Arni School of Hotel Management &
                                    Tourism
                                </a>
                            </li>
                            <li class="mb-2">
                                <a class="text-white cursor-pointer" target="_blank"
                                   rel="noopener noreferrer" (click)="goTo('ashmt-contact')">
                                    <i class="fa fa-link me-2 text-secondary"></i>Arni School of Education & Sports
                                </a>
                            </li>
                        </ul>

                    </div>
                </div>
            </div>

            <!-- Footer Bottom Bar -->
            <div class="footer-bar text-center mt-4 pt-3 border-top border-secondary">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 text-lg-start text-secondary">
                        &copy; 2025 Arni University. All rights reserved.
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 text-lg-end text-secondary">
                        <a (click)="goTo('privacy-policy')" class="text-white cursor-pointer">Privacy Policy</a> | <a
                        (click)="goTo('terms-and-conditions')" class="text-white cursor-pointer">Terms & Conditions</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>









